document.addEventListener('DOMContentLoaded', function () {
  var cartBtn = document.getElementById('embl-cart-btn-test');
  if (!cartBtn) return;

  cartBtn.addEventListener('click', function () {
    var cartDrawer = document.querySelector('.js-cart-drawer');
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open(cartBtn);
    } else {
      window.location.href = (window.theme && theme.routes && theme.routes.cart) || '/cart';
    }
  });
});